import { render, staticRenderFns } from "./assetImpairmentDetail.vue?vue&type=template&id=75704be9"
import script from "./assetImpairmentDetail.vue?vue&type=script&lang=js"
export * from "./assetImpairmentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports